import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
    selector: 'tt-campaigns',
    templateUrl: './campaigns.component.html',
    styleUrls: ['./campaigns.component.css'],
    standalone: false
})
export class CampaignsComponent implements OnInit {
    public page?: CampaignsGet;
    
    public itemsListCampaigns: Item[] = [];
    
    constructor(private datatask: DataTaskService) {}
    
    private async loadPage() {
	    this.page = (await this.datatask.Post(1931))[0];
    }
    
    private async loadCampaigns() {
        if (!this.page) return;

        this.itemsListCampaigns = await this.datatask.Post(1949, { campaign_selected: this.page.campaign_selected });
    }

    public onTabChanged() {
        this.loadCampaigns();
    }
    
    private async init() {
	    await this.loadPage();
        this.loadCampaigns();
    }
    
    ngOnInit() {
	    this.init();
    }
}

interface CampaignsGet {
    campaign_selected: string;
}
